import { Component } from '@angular/core';
import { RouterOutlet } from "@angular/router";
import { IasHeaderComponent } from "../../../common/ias-header/ias-header.component";
import { IasFooterComponent } from "../../../common/ias-footer/ias-footer.component";
import { AccessibilityHeaderComponent } from "../../../common/accessibility-header/accessibility-header.component";

@Component({
  selector: 'app-main-page',
  standalone: true,
  imports: [RouterOutlet, IasHeaderComponent, IasFooterComponent, AccessibilityHeaderComponent],
  templateUrl: './main-page.component.html',
  styleUrl: './main-page.component.scss'
})
export class MainPageComponent {

}
